var lpWidgetSDK, rtSessionId, cust_email;

widgetSDKAPI = lpTag.LPWidgetSDK.API;

var liveperson = {

  addedProducts: false,

  _onEvent: function (eventData) {
    if (eventData && widgetSDKAPI.events.MESSAGES === eventData.type) {
      var content = eventData.data.content || '';

      console.log('MESSAGES data: ', eventData);
      if (content.indexOf('disposeWidget') > -1) {
        liveperson.disposeWidget();
      }
      var rec_index;

      if ((rec_index = content.indexOf('js-hook_product_rec_')) > -1) {
        var prodsku = content.substring(rec_index + 20, content.indexOf('_end', rec_index));
        var prod = prodsku.substring(0, prodsku.indexOf('SKU'));
        var sku = prodsku.substring(prod.length);

        // make call for product data and merge with template...
        generic.jsonrpc.fetch({
          method: 'prodcat.querykey',
          params: [
            {
              'query_key': 'catalog-spp',
              'products': [prod]
            }
          ],
          onSuccess: function (jsonRpcResponse) {
            var data = jsonRpcResponse.getValue();

            // if there are more than one sku - default to the one sent by the Agent
            if (data.products[0].skus.length > 1) {
              var selected_sku = data.products[0].skus.filter(function (psku) {
                return sku === psku.SKU_ID;
              })[0];
              var index = data.products[0].skus.indexOf(selected_sku);

              if (index > -1) {
                data.products[0].skus.splice(index, 1);
              }
              data.products[0].skus.unshift(selected_sku);
            }

            // make url absolute rather than relative @TODO better way...
            try {
              if (parent.location.host === window.location.host) {
                // is accessible and same subdomain - do nothing / leave url as-is
              } else {
                data.products[0].url = 'https://' + document.domain + data.products[0].url;
              }
            } catch (e) {
              // not accessible
              data.products[0].url = 'https://' + document.domain + data.products[0].url;
            }
            page_data['catalog-mpp'].categories[0].products.push(data.products[0]);
            // $(document).trigger('prodcat.status', data);

            var template = $('#rec_mpp_item').html();
            var html = Mustache.render(template, data);

            $('#mpp-product-grid').prepend(html);
            Drupal.behaviors.MPP.attach(html, data);
            liveperson.sendNotification('Received product recommendation');
            $('.chat_widget .add-all-to-cart').toggleClass('hidden', $('.chat_widget .add-to-cart').length < 4);

            liveperson.addedProducts = true;
            setTimeout(liveperson.reInitOnLoadRpc, 1500);
          },
          onFailure: function (jsonRpcResponse) {}
        });
      } else if ((rec_index = content.indexOf('js-hook_email_')) > -1) {
        cust_email = content.substring(rec_index + 14, content.indexOf('_end', rec_index));
        // grab profile pic
        liveperson.getProfilePic(cust_email);
        // grab livechat pics 1 thru 5
        liveperson.clearLiveChatPics();
        liveperson.getLiveChatPics(cust_email);
      }
    } else if (eventData && widgetSDKAPI.events.CONVERSATION_INFO === eventData.type) {
      console.log('CONVERSATION_INFO data: ', eventData);
      rtSessionId = eventData.data.dialogId;
      if (eventData.data.state === 'ended') {
        // @TODO: replace with closing logic here
      }
    } else if (eventData && widgetSDKAPI.events.PARTICIPANTS === eventData.type) {
      console.log('PARTICIPANTS data: ', eventData);
    }
    // sendNotification("Event received!");
  },

  reInitOnLoadRpc: function () {
    if (liveperson.addedProducts) {
      site.onLoadRpc.requests = [];
      site.onLoadRpc.init();
      site.onLoadRpc.fetch();
      liveperson.addedProducts = false;
    }
  },

  clearLiveChatPics: function () {
    $('.shared_image').not('.js-chat_image_profile').remove();
  },

  getLiveChatPics: function (cust_email) {
    for (var i = 1; i < 6; i++) {
      var pic_type = i > 1 ? 'LIVECHAT_' + i : 'LIVECHAT';
      var pic_rpc = generic.jsonrpc.fetch({
        method: 'user.profilePic',
        params: [
          {
            'method': 'retrieve',
            'type': pic_type,
            'pic_index': i,
            'emailAddress': cust_email
          }
        ],
        onSuccess: function (jsonRpcResponse) {
          var data = jsonRpcResponse.getValue() || '/media/images/profile/profile_full.jpg';
          // ugly... but only the picture url is returned, so the url must be parsed to know where it applies...@TODO remove when we start getting index in response
          var live_index = data.indexOf('LIVECHAT_');
          var thumb_index = data.indexOf('_THUMBNAIL');
          var pic_index = live_index == -1 ? 6 : live_index + 8 == thumb_index ? 1 : parseInt(data.substring(live_index + 9, thumb_index));
          var pic_data = {
            'chat_image_index': pic_index,
            'pic_url': data
          };
          var template = $('#livechat_pic').html();
          var html = Mustache.render(template, pic_data);

          $('.js-livechat_pics').append(html);
          // ini delete links
          liveperson.initDeleteLinks(cust_email);

          // init update links...
          liveperson.initUpdatePicLinks(data, pic_index, cust_email);

          // order images...
          liveperson.orderPics();

          // @TODO remove when we start getting index in response
          setTimeout(function () {
            $('.shared_image[data-livechat_index=6]').each(function (index) {
              for (var r = 1; r < 6; r++) {
                if ($('.shared_image[data-livechat_index=' + r + ']').length == 0) {
                  $(this).attr('data-livechat_index', r);
                  $(this).find('[data-livechat_index]').attr('data-livechat_index', r);
                  break;
                }
              }
            });
          }, 1000);
        },
        onFailure: function (jsonRpcResponse) {
          console.log('FAILURE_' + i + ':');
          console.log(jsonRpcResponse);
        }
      });
    }
  },

  getProfilePic: function (cust_email) {
    generic.jsonrpc.fetch({
      method: 'user.profilePic',
      params: [
        {
          'method': 'retrieve',
          'type': 'FACE_PROFILE',
          'emailAddress': cust_email
        }
      ],
      onSuccess: function (jsonRpcResponse) {
        var data = jsonRpcResponse.getValue();

        if (data !== null) {
          $('#widget_profile_pic').attr('src', data);
        }
      },
      onFailure: function (jsonRpcResponse) {
        console.log('FAILURE:');
        console.log(jsonRpcResponse);
      }
    });
  },

  // delete photo
  initDeleteLinks: function (cust_email) {
    $('a.js-image_delete[data-livechat_index]').unbind().on('click', function(evt) {
      evt.preventDefault();
      var del_pic_index = parseInt($(this).attr('data-livechat_index'));
      var del_pic_type = del_pic_index > 1 ? 'LIVECHAT_' + del_pic_index : 'LIVECHAT';

      // LIVECHAT type pictures are deleted via rpc call
      generic.jsonrpc.fetch({
        method: 'user.profilePic',
        params: [
          {
            'method': 'delete',
            'type': del_pic_type,
            'emailAddress': cust_email
          }
        ],
        onSuccess: function (jsonRpcResponse) {
          var data = jsonRpcResponse.getValue();

          console.log('DELETE RESPONSE:');
          console.log(data);
          liveperson.clearLiveChatPics();
          liveperson.getLiveChatPics(cust_email);
        },
        onFailure: function (jsonRpcResponse) {}
      });
    });
  },

  initUpdatePicLinks: function (data, pic_index, cust_email) {
    $('a.js-image_change[data-livechat_index]').on('click', function(evt) {
      evt.preventDefault();
      var up_pic_index = parseInt($(this).attr('data-livechat_index'));
      var up_pic_type = up_pic_index == 0 ? 'FACE_PROFILE' : up_pic_index > 1 ? 'LIVECHAT_' + up_pic_index : 'LIVECHAT';

      // update form hidden values
      $('#form--profile--field--PROFILE_EMAIL_ADDRESS').val(cust_email);
      $('#form--profile--field--PC_EMAIL_ADDRESS').val(cust_email);
      $('#form--profile--field--PROFILE_PIC_TYPE').val(up_pic_type);
      $('.upload_btn').addClass('full_view');
    });
    // show "upload" for default image responses
    if (data.indexOf('/media/images/profile/profile_full.jpg') != -1) {
      $('[data-livechat_index=' + pic_index + '] .js-div_image_update').addClass('hidden');
      $('[data-livechat_index=' + pic_index + '] .js-div_image_upload').removeClass('hidden');
    }
    $('#save_photo').unbind().on('click', function(evt) {
      evt.preventDefault();
      var upload_form = $('form#profile');

      upload_form.ajaxSubmit({
        'url': '/rpc/jsonrpc.tmpl?method=form.rpc',
        'resetForm': true,
        'success': function (response) {
          if (typeof response[0].error !== 'undefined') {
            var errors = response[0].error.data.messages;

            for (var t = 0; t < errors.length; t++) {
              console.log('photo upload error: ' + errors[t].text);
            }
          }
          // reload images
          liveperson.clearLiveChatPics();
          liveperson.getLiveChatPics(cust_email);
        }
      });
    });
  },

  orderPics: function () {
    var $img_pics = $('.js-livechat_pics'),
      $img_divs = $img_pics.children('.shared_image[data-livechat_index]');

    $img_divs.sort(function (a, b) {
      var an = parseInt(a.getAttribute('data-livechat_index')),
        bn = parseInt(b.getAttribute('data-livechat_index'));

      if (an > bn) {
        return 1;
      }
      if (an < bn) {
        return -1;
      }

      return 0;
    });
    $img_divs.detach().appendTo($img_pics);
  },

  sendNotification: function (text) {
    if (typeof text === 'string') {
      lpWidgetSDK.notify({ content: text }, function (err) {
        if (err) {
          console.log('Error on sending notification from widget');
        }
      });
    }
  },

  disposeWidget: function () {
    lpWidgetSDK.dispose(function (data) {
      console.log('disposeWidget called');
    });
  }
};

(function ($) {
  site.addToCart = function (skuData) {
    window.parent.site.addToCart(skuData);
    // manually reset buy btn since site.loading fails to do it
    setTimeout(function () {
      $('.loading-status').remove();
      $('.add-to-cart[data-skubaseid=' + skuData.skuBaseId + ']').show();
    }, 2000);
  };

  // bind lp events
  var bindingEvent = [
      widgetSDKAPI.events.CONVERSATION_INFO,
      widgetSDKAPI.events.MESSAGES,
      widgetSDKAPI.events.PARTICIPANTS
    ],
    opts = { bind: {} };

  bindingEvent.forEach(function (eventName) {
    opts.bind[eventName] = {
      func: liveperson._onEvent,
      context: this
    };
  });
  lpWidgetSDK = lpTag.LPWidgetSDK.init(opts);

  $(window).scroll(function () {
    $('.upload_btn').removeClass('full_view');
  });

  // Add All to Bag functionality
  $('.chat_widget .add-all-to-cart').on('click', function(e) {
    e.preventDefault();
    var skus = [];

    $('.chat_widget .add-to-cart[data-skubaseid]').each(function (i, btn) {
      if (skus.indexOf($(btn).attr('data-skubaseid')) == -1) {
        skus.push($(btn).attr('data-skubaseid'));
      }
    });
    window.parent.site.addToCart({
      skuBaseId: skus
    });
  });

  // init tabs
  $('#tabs').tabs();
  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (iOS) {
    $('#tabs').addClass('iOS');
  }
})(jQuery);
